/* Olives — hareket katmanı: yumuşak kaydırma (Lenis, masaüstü), scroll'a bağlı hero, parallax, sayaç, eğim */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  function init() {
    document.querySelectorAll('.ol-reveal').forEach(function (el) {
      var sibs = Array.prototype.filter.call(el.parentNode.children, function (c) { return c.classList.contains('ol-reveal'); });
      var i = sibs.indexOf(el); if (i > 0) el.style.transitionDelay = Math.min(i * 0.09, 0.45) + 's';
    });
    if (reduce) return;

    // Yumuşak kaydırma (sadece masaüstü fare/trackpad); çekmece/menüler kendi içinde kaysın
    var lenis = null;
    if (false) { // Lenis kapalı: native kaydırma daha akıcı
      lenis = new Lenis({ lerp: 0.1, wheelMultiplier: 1, smoothWheel: true });
      document.querySelectorAll('menu-drawer, cart-drawer, .menu-drawer, .drawer, .facets-wrapper, .mobile-facets, .header__submenu, predictive-search, details-modal').forEach(function (e) { e.setAttribute('data-lenis-prevent', ''); });
      new MutationObserver(function () {
        var locked = document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-tablet') || document.body.classList.contains('overflow-hidden-desktop');
        locked ? lenis.stop() : lenis.start();
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="#"]'); if (!a || a.getAttribute('href').length < 2) return;
        var t = document.querySelector(a.getAttribute('href')); if (t) { e.preventDefault(); lenis.scrollTo(t, { offset: -80 }); }
      });
    }

    // Sayaç
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (!e.isIntersecting) return; io.unobserve(e.target); count(e.target); });
    }, { threshold: 0.4 }) : null;
    if (io) document.querySelectorAll('.ol-num__value').forEach(function (n) { io.observe(n); });
    function count(el) {
      var node = el.firstChild; if (!node || node.nodeType !== 3) return;
      var m = node.nodeValue.match(/^(\s*%?)(\d+(?:[.,]\d+)?)(.*)$/); if (!m) return;
      var dec = (m[2].split(/[.,]/)[1] || '').length, sep = m[2].indexOf(',') > -1 ? ',' : '.';
      var to = parseFloat(m[2].replace(',', '.')), t0 = null, dur = 1800;
      function step(t) {
        if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1), v = to * (1 - Math.pow(1 - p, 4));
        node.nodeValue = m[1] + v.toFixed(dec).replace('.', sep) + m[3];
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    // Scroll'a bağlı: hero görseli büyür, diğer görseller hafif parallax
    var hero = null; // scroll'a bağlı ölçek kapalı (akıcılık)
    var par = []; // parallax kapalı
    var vis = new Set();
    if ('IntersectionObserver' in window) {
      var vo = new IntersectionObserver(function (es) { es.forEach(function (e) { e.isIntersecting ? vis.add(e.target) : vis.delete(e.target); }); });
      par.forEach(function (p) { vo.observe(p); });
    }
    var cur = {}, tgt = {};
    var lastY = -1, idle = 0;
    function frame(time) {
      if (lenis) lenis.raf(time);
      var y = scrollY;
      if (y === lastY) { if (++idle > 40) { requestAnimationFrame(frame); return; } } else { idle = 0; lastY = y; }
      var vh = innerHeight;
      if (hero) {
        var r = hero.getBoundingClientRect();
        var p = Math.min(Math.max(1 - (r.top - 80) / vh, 0), 1); // 0 → 1 görüş alanına girerken
        tgt.h = p;
      }
      vis.forEach(function (el) {
        var r = el.getBoundingClientRect();
        el._t = ((r.top + r.height / 2) - vh / 2) / vh * -36;
      });
      // yumuşatma (lerp) — kaydırma bitince de akmaya devam eder
      if (hero) {
        cur.h = cur.h == null ? tgt.h : cur.h + (tgt.h - cur.h) * 0.12;
        hero.style.transform = 'scale(' + (0.9 + cur.h * 0.1).toFixed(4) + ')';
      }
      vis.forEach(function (el) {
        el._c = el._c == null ? el._t : el._c + (el._t - el._c) * 0.12;
        el.style.transform = 'translate3d(0,' + el._c.toFixed(2) + 'px,0)';
      });
      requestAnimationFrame(frame);
    }
    // rAF döngüsü kapalı (hero ölçek + parallax yok)

    // Kartlarda yumuşak 3B eğim
    if (false) {
      document.querySelectorAll('.ol-tile, .ol-pc').forEach(function (c) {
        var raf;
        c.addEventListener('mousemove', function (e) {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () {
            var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
            c.style.transform = 'perspective(1200px) rotateY(' + (x * 5).toFixed(2) + 'deg) rotateX(' + (-y * 5).toFixed(2) + 'deg) translateY(-6px)';
          });
        });
        c.addEventListener('mouseleave', function () { cancelAnimationFrame(raf); c.style.transform = ''; });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Mega menü: masaüstünde fareyle aç/kapa */
(function(){
  if (!window.matchMedia('(hover:hover) and (pointer:fine)').matches) return;
  var menus = document.querySelectorAll('details.ol-mega');
  menus.forEach(function(d){
    var t;
    d.addEventListener('mouseenter', function(){
      clearTimeout(t);
      menus.forEach(function(o){ if (o !== d) o.removeAttribute('open'); });
      d.setAttribute('open', '');
      var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'true');
    });
    d.addEventListener('mouseleave', function(){
      t = setTimeout(function(){
        d.removeAttribute('open');
        var s = d.querySelector('summary'); if (s) s.setAttribute('aria-expanded', 'false');
      }, 180);
    });
  });
})();

/* Lab raporu: tıklayınca tam boy aç */
document.addEventListener('click', function (e) {
  var i = e.target.closest && e.target.closest('.ol-mt__media img[src*="rapor"]');
  if (i) window.open(i.currentSrc.replace(/([?&])width=\d+/, '$1width=2400'), '_blank', 'noopener');
});
